import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="page _404-page">
      <div className="container">
        <div className="row">
          <div className="col-md-12 content">
            <div className="content">
              <h2>404 Page Not Found</h2>
            <p>For Some Reason The Page You Requested Could Not Be Found On Our Server</p>
            <Link to="/"> Go Back to homepage</Link>
            </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/commons/pages/NotFoundPage.js